/**
 * Divider with Heading.
 *
 * @package
 */

/**
 * Internal dependencies.
 */
 import Edit from './edit';

 /**
  * WordPress Dependencies.
  */ 
 import { registerBlockType } from '@wordpress/blocks';
 import { __ } from '@wordpress/i18n';
 import {
	 RichText,
	 InnerBlocks
 } from '@wordpress/block-editor';
 import { 
	blockTable
} from '@wordpress/icons'; 
 
 /**
  * Register block type.
  */
 registerBlockType( 'ssvreutlingen-blocks/ssvtable', {

	apiVersion: 2,

	 /**
	  * Block title.
	  *
	  * @type {string}
	  */
	 title: __( 'SSV Tabelle', 'ssvreutlingen' ),
 
	 /**
	  * Block icon.
	  *
	  * @type {string}
	  */
	 icon: blockTable,
 
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Tabelle mit Titel und Beschreibungstext.', 'ssvreutlingen' ),
 

	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',
	 attributes: {
		headline: {
			type: 'string',
			source: 'html',
			selector: 'h3',
			default: __( 'Überschrift', 'ssvreutlingen' ),
		},
		description: {
			type: 'string',
			source: 'html',
			selector: 'p',
			default: __( 'Beschreibung', 'ssvreutlingen' ),
		},

	 },
 
	 edit: Edit,
 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
 
     save( { attributes } ) {
		const {
			headline,
			description,
		} = attributes;	
 
        return (
            <div className='page__content -infotable'>
				<section className='page__content-infotable-title text'>
					<RichText.Content 
						value={ headline }
						tagName='h3'
					/>
					<RichText.Content 
						value={ description }
						tagName='p'
					/>
				</section>
				<section className='page__content-infotable-content'>
                	<InnerBlocks.Content />
				</section>
            </div>
        );
    },
 } );
 